import MentorshipStatusChip from 'components/Chips/MentorshipStatusChip';
import getFilters from 'components/Filters';
import List from 'components/list';
import { BoldTd, Td } from 'components/list/Td';
import { Th } from 'components/list/Th';
import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { setPage, setSearch, setTake } from 'store/actions/admin/actions';
import { StoreState } from 'store/reducers';
import useSWR from 'swr';
import Mentorship from 'types/Mentorship';
import { Action } from 'types/typeguards/reducerActions';

const Filters = getFilters<never>();

const columnNames = [
  'firstName',
  'lastName',
  'status',
  'mentorName',
  'view',
] as const;
type ColumnName = typeof columnNames[number];
const activeColumns: Record<ColumnName, boolean> = {
  firstName: true,
  lastName: true,
  status: true,
  mentorName: true,
  view: true,
};

type RetrievedData = {
  mentorships: Mentorship[] | undefined;
  pages: number | undefined;
};

type Props = {
  page: number;
  setPage: (page: number) => void;
  search: string;
  setSearch: (search: string) => void;
  take: number;
  setTake: (take: number) => void;
};

const MentorshipActions: FC<Props> = ({
  page,
  setPage,
  search,
  setSearch,
  take,
  setTake,
}) => {
  const { data, error } = useSWR<RetrievedData>(
    `/user/notification/admin/mentorship?page=${page}&take=${take}${
      search ? `&search=${search}` : ''
    }`,
  );

  const [retrievedData, setRetrievedData] = useState<RetrievedData>({
    mentorships: undefined,
    pages: undefined,
  });
  useEffect(() => {
    if (data) {
      setRetrievedData(data);
    }
  }, [data]);

  return (
    <>
      <Filters
        tagList={[]}
        setTags={() => null}
        setSearch={setSearch}
        state={{ tags: [], search, take }}
        setTake={setTake}
      />
      <List
        isEmpty={!retrievedData.mentorships?.[0]}
        emptyText="Il n'y a aucune action à effectuer pour les mentorats"
        pages={retrievedData.pages}
        page={page}
        setPage={setPage}
        loading={!data && !error}
        columnNumber={5}
        activeColumns={activeColumns}
      >
        <Th name="firstName">Prénom</Th>
        <Th name="lastName">Nom</Th>
        <Th name="status">Statut du mentorat</Th>
        <Th name="mentorName">Mentor</Th>
        <Th name="view" />
        {retrievedData.mentorships?.map((mentorship, idx) => (
          <React.Fragment key={idx}>
            <BoldTd name="firstName">
              <Link
                to={`/admin/mentoring/mentees/${mentorship?.mentee?.id}/mentoring/`}
              >
                {mentorship?.mentee?.firstName}
              </Link>
            </BoldTd>
            <BoldTd name="lastName">
              <Link
                to={`/admin/mentoring/mentees/${mentorship?.mentee?.id}/mentoring/`}
              >
                {mentorship?.mentee?.lastName}
              </Link>
            </BoldTd>
            <Td name="status">
              {mentorship?.status && (
                <MentorshipStatusChip status={mentorship.status} />
              )}
            </Td>
            <Td name="mentorName">{`${mentorship?.mentor?.firstName} ${mentorship?.mentor?.lastName}`}</Td>
            <Td name="view"></Td>
          </React.Fragment>
        ))}
      </List>
    </>
  );
};

const mapStateToProps = (state: StoreState) => {
  return {
    page: state.admin.actions.mentorship.page,
    search: state.admin.actions.mentorship.search,
    take: state.admin.actions.mentorship.take,
  };
};

const mapDispatchToProps = (dispatch: (action: Action) => void) => {
  return {
    setPage: (page: number) => dispatch(setPage('mentorship', page)),
    setSearch: (search: string) => dispatch(setSearch('mentorship', search)),
    setTake: (take: number) => dispatch(setTake('mentorship', take)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MentorshipActions);
